const themeMarkerSelector = "[data-workspace-theme], [data-application-theme]";

/** The favicon is a separate document, so it cannot inherit our CSS tokens. */
export function installWorkspaceFavicon() {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

  if (!link) {
    return;
  }

  void loadWorkspaceFavicon(link);
}

async function loadWorkspaceFavicon(link: HTMLLinkElement) {
  try {
    const response = await fetch(link.href);

    if (!response.ok) {
      return;
    }

    const svg = new DOMParser().parseFromString(
      await response.text(),
      "image/svg+xml",
    );
    const background = svg.querySelector("rect");
    const glyph = svg.querySelector("g");

    if (!background || !glyph || svg.querySelector("parsererror")) {
      return;
    }

    let previousColors = "";

    const update = () => {
      const style = getComputedStyle(document.documentElement);
      const fill = style.getPropertyValue("--primary").trim();
      const stroke = style.getPropertyValue("--primary-foreground").trim();
      const colors = `${fill}/${stroke}`;

      if (!fill || !stroke || colors === previousColors) {
        return;
      }

      previousColors = colors;
      background.setAttribute("fill", fill);
      glyph.setAttribute("stroke", stroke);
      link.href = `data:image/svg+xml,${encodeURIComponent(new XMLSerializer().serializeToString(svg))}`;
    };

    // Only theme changes trigger style reads; ordinary page mutations do not.
    const observer = new MutationObserver((records) => {
      if (
        records.some((record) =>
          record.type === "attributes"
            ? record.target === document.documentElement ||
              record.attributeName !== "class"
            : [...record.addedNodes, ...record.removedNodes].some(
                containsThemeMarker,
              ),
        )
      ) {
        update();
      }
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [
        "class",
        "data-workspace-theme",
        "data-application-theme",
      ],
      childList: true,
      subtree: true,
    });
    update();
  } catch {
    // Offline or blocked icon requests retain the static fallback.
  }
}

function containsThemeMarker(node: Node): boolean {
  return (
    node instanceof Element &&
    (node.matches(themeMarkerSelector) ||
      node.querySelector(themeMarkerSelector) != null)
  );
}
